import React from 'react';
import ActionIconButton from './ActionIconButton';

const BackButton = ({onClick, title = 'Voltar', ...props}) => {
    const handleBackClick = (event) => {
        if (onClick) {
            onClick(event);
        } else {
            window.history.back();
        }
    };

    return (
        <ActionIconButton variant="back" title={title} onClick={handleBackClick} {...props}/>
    );
};

export default BackButton;
